export const CMP_LOCAL_STORAGE_USER_SELECTION_KEY = 'cmp_user_select';
export const ANALYTICS_CMP_KEY = 'c54';

export const getAnalyticsCookies = (cmpData = {}) => {
    const { purposeConsents = {} } = cmpData;

    const value = !!purposeConsents[ANALYTICS_CMP_KEY];

    return value;
};

export const hasAnalyticsCookies = () => !!localStorage.getItem(CMP_LOCAL_STORAGE_USER_SELECTION_KEY);
